import { render, staticRenderFns } from "./Installations.vue?vue&type=template&id=bd991084&scoped=true&"
import script from "./Installations.vue?vue&type=script&lang=js&"
export * from "./Installations.vue?vue&type=script&lang=js&"
import style0 from "./Installations.vue?vue&type=style&index=0&id=bd991084&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd991084",
  null
  
)

export default component.exports